import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import FeatureMappedWithUser from "./FeatureMappedWithUser";

const MappedPages = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
  callFunction,
  userInfoData,
}) => {
  const { mappedPages, dashboardFeaturesLoading } = useSelector(
    (state) => state.features
  );

  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);
  const iniClickValues = {
    isModOpen: false,
    rowData: "",
    cardName: "",
  };
  const [clickValues, setClickValues] = useState(iniClickValues);

  function onCloseModal() {
    setClickValues(iniClickValues);
  }

  useEffect(() => {
    if (
      mappedPages?.status &&
      mappedPages?.data?.length > 0 &&
      !dashboardFeaturesLoading
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: mappedPages.data,
        pagination:
          mappedPages?.pagination?.length > 0 ? mappedPages.pagination : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [mappedPages, dashboardFeaturesLoading]);

  const tbColumns = [
    {
      dataField: "user_id",
      text: "user detail",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.name || "NA"}
            <br />
            <small className="lowercase underline gray">
              {row?.mobile || ""}
              <br />
              {row?.email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "account_type",
      text: "role",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.account_type?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "feature_group_id",
      text: "feature group",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.feature_group_name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "feature_assigned",
      text: "total features mapped",
      formatter: (_, row) => {
        const featureNo = Number(row?.feature_assigned || 0);

        return (
          <span
            className={`tb-data ${featureNo ? "link" : ""}`}
            onClick={() =>
              featureNo
                ? setClickValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardName: "feature_assigned",
                    rowData: row,
                  }))
                : null
            }
          >
            {featureNo}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon edit"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "edit",
                rowData: row,
              }))
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M3.62891 17.3603V20.3254C3.62891 20.5985 3.84349 20.8131 4.1166 20.8131H7.08175C7.20855 20.8131 7.33535 20.7643 7.42313 20.6668L18.0743 10.0254L14.4166 6.36775L3.77521 17.0091C3.67768 17.1067 3.62891 17.2237 3.62891 17.3603ZM20.9029 7.19682C20.9933 7.10658 21.065 6.9994 21.114 6.88141C21.1629 6.76341 21.1881 6.63692 21.1881 6.50918C21.1881 6.38143 21.1629 6.25495 21.114 6.13695C21.065 6.01896 20.9933 5.91177 20.9029 5.82154L18.6205 3.53915C18.5302 3.44873 18.4231 3.37699 18.3051 3.32805C18.1871 3.2791 18.0606 3.25391 17.9328 3.25391C17.8051 3.25391 17.6786 3.2791 17.5606 3.32805C17.4426 3.37699 17.3354 3.44873 17.2452 3.53915L15.4603 5.32409L19.1179 8.98176L20.9029 7.19682Z"
                fill="url(#paint0_linear_14023_4477)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_14023_4477"
                  x1="3.62891"
                  y1="11.6344"
                  x2="21.1881"
                  y2="11.6344"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.0447915" stopColor="#B4000B" />
                  <stop offset="1" stopColor="#DD0000" />
                </linearGradient>
              </defs>
            </svg>
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer`}>
          <div className="modalHeadAndCloseContainer mod-with-details">
            <div className="user-info">
              <div className="user-details">
                <span className="mod-header">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="33"
                    height="33"
                    viewBox="0 0 33 33"
                    fill="none"
                    onClick={onCloseModal}
                  >
                    <g id="navigate_before">
                      <path
                        id="icon"
                        d="M19.25 24.75L11 16.5L19.25 8.25L21.175 10.175L14.85 16.5L21.175 22.825L19.25 24.75Z"
                        fill="#1D1B20"
                      />
                    </g>
                  </svg>
                  {clickValues.rowData?.name || "NA"}
                </span>
                <span className="mod-regular-text underline">
                  +91 {clickValues.rowData?.mobile || ""}
                </span>
                <span className="mod-regular-text lowercase underline">
                  {clickValues.rowData?.email || ""}
                </span>
                <span className="mod-light-text">
                  <b>
                    {clickValues.rowData?.account_type?.replace(/_/g, " ") ||
                      ""}
                  </b>
                </span>
              </div>
            </div>

            <button
              type="button"
              className="closeModalBtn hideMobile"
              onClick={onCloseModal}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-x-lg"
                viewBox="0 0 16 16"
              >
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
              </svg>
            </button>
          </div>

          <FeatureMappedWithUser
            userInfoData={userInfoData}
            rowData={clickValues.rowData}
            callFunction={callFunction}
          />
        </div>
      </Modal>

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
        {dashboardFeaturesLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allData}
            tableColumns={tbColumns}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            isFirstColSticky={true}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>
    </>
  );
};

export default MappedPages;
